import { render, staticRenderFns } from "./Ajuste.vue?vue&type=template&id=e6897148"
import script from "./Ajuste.vue?vue&type=script&lang=js"
export * from "./Ajuste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports